import React from "react";
import {
  Container,
  Header,
  SpaceBetween,
  Box,
  Button,
} from "@cloudscape-design/components";

const MonitorAlert: React.FC = () => {
  return (
    <Container
      header={
        <Header
          variant="h1"
          description="Manufacturing Performance Metrics Dashboard"
        >
          Monitor & Alert
        </Header>
      }
    >
      <SpaceBetween direction="vertical" size="l">
        {/* Dashboard Display Container - No Black Flash */}
        <Box>
          <style>
            {`
              .dashboard-container {
                width: 100%;
                height: 1300px;
                background: #ffffff;
                border-radius: 8px;
                box-shadow: 0 2px 8px rgba(0,0,0,0.1);
                position: relative;
                overflow: auto;
                display: block;
              }
              .dashboard-image {
                width: 105%;
                height: auto;
                min-height: 100%;
                object-fit: contain;
                background: #ffffff;
                display: block;
                margin-left: -2.5%;
              }
              .dashboard-fallback {
                text-align: center;
                color: #666;
                font-size: 18px;
                padding: 40px;
              }
            `}
          </style>
          <div className="dashboard-container">
            <img
              className="dashboard-image"
              src={require('../../assets/images/monitor_alert.pdf.png')}
              alt="Manufacturing Performance Metrics Report"
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.style.display = "none";
                const fallback = target.nextElementSibling as HTMLElement;
                if (fallback) fallback.style.display = "block";
              }}
            />
            <div className="dashboard-fallback" style={{ display: "none" }}>
              <h3>Manufacturing Performance Metrics Dashboard</h3>
              <p>📊 Real-time production metrics and KPIs</p>
              <p>⚡ Equipment efficiency monitoring</p>
              <p>📈 Quality control analytics</p>
              <p>🔔 Alert management system</p>
              <Button
                variant="primary"
                onClick={() => window.open("/monitor_alert.pdf", "_blank")}
              >
                View Full Report (PDF)
              </Button>
            </div>
          </div>
        </Box>
      </SpaceBetween>
    </Container>
  );
};

export default MonitorAlert;
